import React from "react";

const SvgArrowTxt = props => {
  const { cls, children } = props;
  return <div className={`svg-arrow-txt ${cls}`}>{children}</div>;
};

export default SvgArrowTxt;
